import { nameValidator } from "~/core/validators/validators";

export function getNameFieldLogic() {
  const name = ref("");
  const nameField = ref<any>(null);
  function resetNameValidation() {
    nameField.value!.resetValidation();
  }

  return {
    name,
    nameField,
    nameValidator,
    resetNameValidation,
  };
}
